import { render, staticRenderFns } from "./ednCatalogue.vue?vue&type=template&id=335708bb"
import script from "./ednCatalogue.vue?vue&type=script&lang=js"
export * from "./ednCatalogue.vue?vue&type=script&lang=js"
import style0 from "./ednCatalogue.vue?vue&type=style&index=0&id=335708bb&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports